import { getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";
import {
    getCurrentLanguage,
    getSettingsCollection,
    getWebsite,
} from "@toolkit/Framework/Store/Context/ContextSelectors";

export const useSettingsCollection = convertSelectorToHook(getSettingsCollection);
export const useWebsite = convertSelectorToHook(getWebsite);
export const useCurrentLanguage = convertSelectorToHook(getCurrentLanguage);
export const useIsPunchOutSession = convertSelectorToHook(getIsPunchOutSession);
